module.exports = __webpack_public_path__ + "static/media/static-ca.eedcac20.png";